module.exports = __webpack_public_path__ + "img/alias.c7701037.svg";